<template>
  <div @click="jumpDetail" style="width: 360px; height: 240px"
    class="flex justify-center items-center px-2 pt-3 bg-light-100 rounded-lg shadow-lg mb-5 cursor-pointer transform transition-transform duration-300 hover:scale-105 hover:brightness-125">
    <img class="center rounded-[4px]" :src="props.info.coverUrl" style="width: 150px; height: 210px" />
    <div class="flex-1 mx-3 overflow-hidden">
      <p class="font-bold">{{ props.info.name }}</p>
      <div class="mt-4 line-clamp-7 overflow-hidden" style="width: 166px; height: 141px;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 7;line-clamp: 7;">
        {{ props.info.synopsis }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import useJumpWithQuery from "../../hooks/useJumpWithQuery";
const props = defineProps({
  info: {
    type: Object,
    default: () => ({}),
  },
});
// console.log(props.info);
const useJump = useJumpWithQuery();

const router = useRouter()
const jumpDetail = () => {
  const href = router.resolve({
    path: '/course/info',
    query: {
      courseId: props.info.id,
    }
  })
  window.open(href.href, '_blank')
  // useJump("/course/info", {
  //   courseId: props.info.id,
  // });
};
</script>
